<template>
  <div class="fixed w-full h-full top-0 left-0 flex items-center justify-center z-10" @click.self="close">
    <div class="absolute w-full h-full bg-gray-900 opacity-50" @click="close"></div>

    <div class="absolute max-h-full w-1/3">
      <div class="container bg-white overflow-hidden md:rounded">
        <div class="px-4 py-4 leading-none flex justify-between items-center font-medium text-sm bg-gray-100 border-b select-none">
          <h3>{{ title }}</h3>
          <div @click.self="close" class="text-2xl hover:text-gray-600 cursor-pointer">&#215;</div>
        </div>
        <div class="max-h-full px-4 py-4">
          <div class="modal-header">
            <h2 class="text-lg font-bold mb-4">
              <slot name="title"></slot>
            </h2>
          </div>
          <div class="modal-body">
            <slot name="content"></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  props: {
    title: {
      type: String,
      default: 'Modal Title',
    },
  },
  methods: {
    close() {
      this.$emit('close')
    },
  },
}
</script>


  <style scoped>
.fixed {
  backdrop-filter: blur(5px);
}
</style>
